export const LESSON_MATTERS_TITLE = 'Why This Lesson Matters'
